import { BookOpenCheckIcon, ClipboardCheckIcon, HistoryIcon, LayersIcon, SigmaIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Chemistry Practice Problem Bank with Answer Keys',
    icon: ClipboardCheckIcon,
  },
  {
    number: '2',
    title: 'Periodic Table & Element Profile Cards',
    icon: LayersIcon,
  },
  {
    number: '3',
    title: 'Illustrated Chemistry Glossary & Vocabulary Cards',
    icon: BookOpenCheckIcon,
  },
  {
    number: '4',
    title: 'Chemistry Quick-Reference Charts & Formula Sheets',
    icon: SigmaIcon,
  },
  {
    number: '5',
    title: 'Landmark Discoveries in Chemistry: Timeline & Scientist Case Studies',
    icon: HistoryIcon,
  },
];
